import { makeStyles } from '@material-ui/core';
import { FC } from 'react';
import androidIcon from 'src/asset/android.svg';
import appleIcon from 'src/asset/apple.svg';
import {
  AndroidApp,
  AppleApp
} from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { AppType } from 'src/page/DynamicLinksConfig/interfaces/appType.interface';

const useStyle = makeStyles({
  sidebarItem: {
    '&.selected': {
      backgroundColor: '#F0F4FF',
      color: '#5564F8'
    },
    '&:hover': {
      backgroundColor: '#F0F4FF'
    },
    alignItems: 'center',
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.85)',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '13px',
    gap: '8px',
    lineHeight: '20px',
    minHeight: '56px',
    padding: '0 8px 0 16px',
    transition: 'background-color 0.15s ease-in-out, color 0.15s ease-in-out'
  },
  sidebarItemIcon: {
    '& > img': {
      marginBottom: '2px',
      maxHeight: '18px',
      maxWidth: '18px'
    },
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #5564F8',
    borderRadius: '50%',
    boxSizing: 'border-box',
    color: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    flex: 'none',
    height: '36px',
    justifyContent: 'center',
    width: '36px'
  },
  sidebarItemSubtitle: {
    color: 'inherit',
    fontSize: '12px',
    lineHeight: '16px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  sidebarItemTitle: {
    color: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});

interface ProjectAppsSidebarItemProps {
  appData: AndroidApp | AppleApp;
  appType: AppType;
  onClick: () => void;
  selected: boolean;
}

const ProjectAppsSidebarItem: FC<ProjectAppsSidebarItemProps> = ({
  appData,
  appType,
  onClick,
  selected
}) => {
  const classes = useStyle();

  const { imgAlt, imgSrc, subtitle, title } =
    appType === AppType.android
      ? {
          imgAlt: 'android icon',
          imgSrc: androidIcon,
          subtitle: (appData as AndroidApp).packageName,
          title: appData.name
        }
      : {
          imgAlt: 'apple icon',
          imgSrc: appleIcon,
          subtitle: (appData as AppleApp).bundleId,
          title: appData.name
        };

  return (
    <div className={`${classes.sidebarItem} ${selected ? 'selected' : ''}`} onClick={onClick}>
      <div className={classes.sidebarItemIcon}>
        <img alt={imgAlt} src={imgSrc} />
      </div>

      <div>
        <div className={classes.sidebarItemTitle}>{title}</div>

        <div className={classes.sidebarItemSubtitle}>{subtitle}</div>
      </div>
    </div>
  );
};

export default ProjectAppsSidebarItem;
